export interface ContractManagerWsToken {
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: string;
  date: Date;
}

export interface ContractManagerWsError {
  error: string;
  error_description: string;
}

export interface ContractManagerServiceConfig {
  [insurerId: string]: ContractManagerServiceAuthConfig;
}

export interface ContractManagerServiceAuthConfig {
  rootUrl?: string;
  authUrl?: string;
  credentials?: ContractManagerServiceCredentials;
  sftpUrl?: string;
  sftpCredentials?: ContractManagerSFTPCredentials;
}

export interface ContractManagerServiceCredentials {
  client_id: string;
  client_secret: string;
  grant_type: string;
  scope?: string;
  audience?: string;
}

export interface ContractManagerSFTPCredentials {
  username: string;
  password: string;
}
